import { AddEdit } from '../../../../../interfaces/productDivision.interface';
import { Validation } from '../../../../../interfaces/common';
import { VALIDATION_FIELD_MAPPING } from '../../../../../utils/appConstant';
import translate from '../../../../../i18n/config';

export const validateAddEditForm = (formData: AddEdit, fieldName?: string): Validation => {
  let validation: Validation = { validate: true, fields: [] };

  if (!fieldName || fieldName === VALIDATION_FIELD_MAPPING.name) {
    if (!formData.name?.trim()) {
      validation.validate = false;
      validation.fields.push({
        field: VALIDATION_FIELD_MAPPING.name,
        message: translate.t('productDivisions.addEdit.pageTexts.form.name.errors.required'),
      });
    }
  }

  if (!fieldName || fieldName === VALIDATION_FIELD_MAPPING.description) {
    if (!formData.description?.trim()) {
      validation.validate = false;
      validation.fields.push({
        field: VALIDATION_FIELD_MAPPING.description,
        message: translate.t('productDivisions.addEdit.pageTexts.form.description.errors.required'),
      });
    }
  }

  return validation;
};
